export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'LU',
  'merchantReturnLink': 'https://www.timberland.lu/de-lu/kundenservice/ruckversand',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
